/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import {FontWeight} from 'components/Text';
import { mediaHelperMaxWidth, mediaHelper } from "utils/src";
import Label from 'components/Form/Label';

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 20px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

export const Text = styled.text`
  color:${props => props.secundary ? Colors.PURPLE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;
`;

export const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${Colors.GRAY[4]};
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  left: 45px;
  position: relative;
`;

export const FieldWrapper = styled.div`
  padding: 10px;
  position: relative;
  display: ${({ flex }) => flex ? `flex` : 'block'};
  width: ${({ desktopWidth }) => desktopWidth ? `${desktopWidth}%` : '33%'};
  min-width: ${({ desktopWidth }) => desktopWidth ? `${desktopWidth}%` : '33%'};

  ${mediaHelperMaxWidth.md`
    width: ${({ tabletWidth }) => tabletWidth ? `${tabletWidth}%` : '50%'};
    min-width: ${({ tabletWidth }) => tabletWidth ? `${tabletWidth}%` : '50%'};
  `}

  ${mediaHelperMaxWidth.sm`
    width: ${({ mobileWidth }) => mobileWidth ? `${mobileWidth}%` : '100%'};
    min-width: ${({ mobileWidth }) => mobileWidth ? `${mobileWidth}%` : '100%'};
  `}
`;

export const Label1 = styled(Label)`
  display: block;
  color: ${Colors.GRAY[2]};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  
  ${mediaHelper.sm`
    font-size: 14px;
  `}
`;

export const Text1 = styled.text`
  display: block;
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 14px;
  margin-bottom: 5px;
  
  ${mediaHelper.sm`
    font-size: 16px;
  `}
`;

export const VerticalGapContent = styled.div`
  padding: 10px 0 0;
`;

export const IconButton = styled.button`
  display: flex;
  width:50px;
  height:50px;
  border: 0px;
  background-color:transparent;
  cursor: pointer;
  align-self: center;
`;

